import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function ClientsClientPage(): React.ReactElement {
  const currentSecurity = useSecurity('Clients', 'Client');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Clients/Scripts/Resources/en/res.Client.en.js",
        "Areas/Clients/Scripts/Resources/en/Types.en.js",
        "Areas/Clients/Scripts/Enums.js",
        "Areas/Clients/Scripts/Client/Index.js"], "initClientsClient", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
